(function () {
  const modal = document.getElementById("inkdAiHeroModal");
  if (!modal) return;

  const panel = modal.querySelector(".inkdModal__panel");
  const closeEls = modal.querySelectorAll("[data-inkd-modal-close]");
  const focusableSel = 'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

  let lastActive = null;

  function isOpen() { return !modal.hasAttribute("hidden"); }

  function openModal(prefill) {
    if (isOpen()) return;
    lastActive = document.activeElement;

    modal.removeAttribute("hidden");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("inkdModalOpen");

    const input = modal.querySelector('[data-role="input"]');
    if (input && typeof prefill === "string" && prefill.trim()) {
      input.value = prefill.trim();
    }

    requestAnimationFrame(() => {
      (panel || modal).focus();
      if (input) input.focus();
    });
  }

  function closeModal() {
    if (!isOpen()) return;

    modal.setAttribute("hidden", "");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("inkdModalOpen");

    if (lastActive && lastActive.focus) lastActive.focus();
    lastActive = null;
  }

  window.INKD_AI_HERO_MODAL = {
    open: openModal,
    close: closeModal,
    isOpen
  };

  closeEls.forEach((el) => el.addEventListener("click", closeModal));

  document.addEventListener("keydown", (e) => {
    if (!isOpen()) return;
    if (e.key === "Escape") closeModal;

    if (e.key === "Tab") {
      const nodes = Array.from(modal.querySelectorAll(focusableSel)).filter(n => n.offsetParent !== null);
      if (!nodes.length) return;

      const first = nodes[0];
      const last = nodes[nodes.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  modal.addEventListener("click", (e) => {
    const chip = e.target.closest("[data-chip]");
    if (!chip) return;
    const txt = chip.getAttribute("data-chip") || "";
    const input = modal.querySelector('[data-role="input"]');
    const form = modal.querySelector("form.inkd-aihero__form");
    if (input) input.value = txt;
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });
})();
